module.exports = __webpack_public_path__ + "static/media/non-gmo.1c7135c1.png";